export enum VignetteQueryStrings {
  BRIEFCASE_PAGE = "page",
  SEARCH_PAGE = "page",
  SEARCH_PAGE_SIZE = "pageSize",
  SEARCH_Q = "q",
  SEARCH_AUTOCOMPLETE = "autocomplete",
}

export interface VignetteQueryString {
  queryString: VignetteQueryStrings | string;
  value: string;
}
